import { combineReducers } from 'redux';

import { academic } from './academic/academic';
import { offers } from './offers/offers';
import { recipient } from './recipient/recipient';
import { sender } from './sender/sender';

const fields = combineReducers({
  offers,
  recipient,
  sender,
  academic,
});

export { fields };
